import { defHttp } from '/@/utils/http/axios';
import {
  LoginParams,
  LoginPhoneParams,
  LoginResultModel,
  GetUserInfoModel,
  SignUpParams,
  GetUserInfoTeamModel,
  LoginConfirmParams,
  User,
  IVerificationCode,
  IEventStatistic,
  IMarkEventDone,
} from './model/userModel';
// import { BasicIdParams } from '/@/api/model/baseModel';
import { ErrorMessageMode } from '/#/axios';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(timezone);

export enum Api {
  USER = '/user',
}

export function loginConfirmApi(params: LoginConfirmParams, mode: ErrorMessageMode = 'none') {
  return defHttp.get<undefined>(
    {
      url: `${Api.USER}/auth/login/confirm`,
      params,
    },
    {
      errorMessageMode: mode,
    },
  );
}

export function checkUserOnline(params: { username: string }) {
  return defHttp.post<undefined>({
    url: `${Api.USER}/auth/checkUserOnline`,
    params,
  });
}

/**
 * @description: user login api
 */
export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
  return defHttp.post<LoginResultModel>(
    {
      url: `${Api.USER}/auth/login`,
      params,
    },
    {
      isTransformResponse: false,
      errorMessageMode: mode,
    },
  );
}

/**
 * @description: user login phone api
 */
export function loginPhoneApi(params: LoginPhoneParams, mode: ErrorMessageMode = 'modal') {
  return defHttp.post<LoginResultModel>(
    {
      url: `${Api.USER}/auth/phone/login`,
      params,
      headers: {
        timezone: dayjs.tz.guess(),
      },
    },
    {
      isTransformResponse: false,
      errorMessageMode: mode,
    },
  );
}

/**
 * @description: 获取手机验证码
 */
export const getVerificationCode = (params: IVerificationCode) => {
  return defHttp.post<any>({
    url: `${Api.USER}/auth/phone/sendVerificationCode`,
    params,
  });
};

/**
 * @description: 校验验证码
 */
export const checkVerificationCode = (params: { phoneNumber: string; code: string }) => {
  return defHttp.post<any>({
    url: `${Api.USER}/auth/phone/checkVerificationCode`,
    params,
  });
};

/**
 * @description: getUserInfo
 */
export function getUserInfo() {
  return defHttp.get<GetUserInfoModel>({ url: `${Api.USER}/user/logged` });
}

export function getGlobalConfig() {
  return defHttp.get<any>({ url: `${Api.USER}/config/globalConfig` });
}

export function getPermCode() {
  return defHttp.get<string[]>({ url: `${Api.USER}/user/permission` });
}

export function doLogout() {
  return defHttp.get({ url: `${Api.USER}/user/logout` });
}

export function signUpEmail(params: { email: string }) {
  return defHttp.get<undefined>({
    url: `${Api.USER}/auth/register/email`,
    params,
  });
}

export function signUpApi(params: SignUpParams) {
  return defHttp.post<LoginResultModel>({
    url: `${Api.USER}/auth/create`,
    params,
    headers: {
      timezone: dayjs.tz.guess(),
    },
  });
}

export const resetPwdSendEmail = (params: { email: string }) =>
  defHttp.get<undefined>({
    url: `${Api.USER}/auth/resetPassword/email`,
    params,
  });

export const resetPwdApi = (params: { token: string; newPassword: string }) =>
  defHttp.post<undefined>({
    url: `${Api.USER}/auth/resetPassword`,
    params,
  });

export const resetPhonePwdApi = (params: {
  phoneNumber: string;
  newPassword: string;
  code: string;
}) =>
  defHttp.post<undefined>({
    url: `${Api.USER}/auth/phone/resetPassword`,
    params,
  });

export const updateUser = (params: {
  user: {
    id?: string | number;
    nickname?: string;
    avatarUrl?: string;
    phone?: string;
    password?: string;
    newPassword?: string;
  };
}) =>
  defHttp.post<User>({
    url: `${Api.USER}/user/update`,
    params,
  });

export const updateInlandUser = (params: {
  user: {
    id?: number;
    nickname?: string;
    avatarId?: number;
    authPhone?: string;
    newPassword?: string;
  };
  cose?: string;
}) =>
  defHttp.post<User>({
    url: `${Api.USER}/user/inland/update`,
    params,
  });

export const fetchUser = (params: { id: string | number }) =>
  defHttp.get<GetUserInfoTeamModel>({
    url: `${Api.USER}/user/info/${params.id}`,
  });

export const fetchPermission = () =>
  defHttp.get<string[]>({
    url: `${Api.USER}/user/permission`,
  });

export const fetchLang = () =>
  defHttp.get<string[]>({
    url: `${Api.USER}/lang/list`,
  });

export const confirmJoinTeam = (params: any) =>
  defHttp.post<string[]>({
    url: `${Api.USER}/user/inviteJoinTeam/confirm/${params.inviteCode}`,
    params,
  });

// 临时接口
export const getSecret = () =>
  defHttp.post<string>({
    url: `user/billingInvoice/createPayment`,
  });

export const emailAuthentication = (url) =>
  defHttp.get<string[]>(
    {
      url,
    },
    {
      apiUrl: '',
    },
  );

/** Home */
export const getEventStatisticsApi = () =>
  defHttp.get<IEventStatistic>({
    url: `${Api.USER}/teamMember/getEventStatistics`,
  });
export const markEventDoneApi = (params: IMarkEventDone) =>
  defHttp.post<null>({
    url: `${Api.USER}/teamMember/markEventDone`,
    params,
  });
